import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'help_center-view_all_popular_guides-click';
/**
 * Click event when user clicks &quot;view all&quot; under popular guides section in the help center home page
 */
export function trackHelpCenterViewAllPopularGuidesClick(section, retailerToken, brandToken) {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
        parameters: { section, retailerToken, brandToken },
    });
}
